import React from 'react'

interface VendorTypeBadgesProps {
  specialties: string[]
  size?: 'small' | 'medium' | 'large'
}

interface Badge {
  type: string
  color: string
  icon: string
}

export const getVendorBadges = (specialties: string[]): Badge[] => {
  const badges: Badge[] = []
  const specialtiesText = specialties.join(' ').toLowerCase()
  
  // Check for 7OH products
  if (specialtiesText.includes('7oh') || specialtiesText.includes('7-oh')) {
    badges.push({ type: '7OH', color: '#9333ea', icon: '💊' })
  }
  
  // Check for MIT extracts
  if (specialtiesText.includes('mit') || specialtiesText.includes('mitragynine extract')) {
    badges.push({ type: 'MIT', color: '#eab308', icon: '⚗️' })
  }
  
  // Check for Pseudoindoxyl products
  if (specialtiesText.includes('pseudo') || specialtiesText.includes('pseudoindoxyl')) {
    badges.push({ type: 'Pseudo', color: '#dc2626', icon: '🧬' })
  }
  
  // Check for traditional kratom (strains, colors, traditional terms)
  if (specialtiesText.includes('red') || specialtiesText.includes('green') || specialtiesText.includes('white') || 
      specialtiesText.includes('maeng da') || specialtiesText.includes('bali') || specialtiesText.includes('borneo') ||
      specialtiesText.includes('horn') || specialtiesText.includes('elephant') || specialtiesText.includes('malay') ||
      specialtiesText.includes('sumatra') || specialtiesText.includes('thai') || specialtiesText.includes('gold') ||
      specialtiesText.includes('bulk powder') || specialtiesText.includes('sample packs') || 
      (specialtiesText.includes('traditional') || (!specialtiesText.includes('7oh') && !specialtiesText.includes('mit')))) {
    badges.push({ type: 'Plain Leaf', color: '#059669', icon: '🌿' })
  }
  
  return badges
}

export default function VendorTypeBadges({ specialties, size = 'medium' }: VendorTypeBadgesProps) {
  const badges = getVendorBadges(specialties)
  
  const sizeClasses = {
    small: 'text-xs px-1.5 py-0.5',
    medium: 'text-sm px-2 py-1', 
    large: 'text-base px-3 py-1.5'
  }
  
  return (
    <div className="vendor-badges">
      {badges.map((badge, index) => (
        <span 
          key={index} 
          className={`vendor-type-badge ${sizeClasses[size]}`}
          style={{ backgroundColor: badge.color }}
          title={`${badge.type} Specialist`}
        >
          {badge.icon} {badge.type}
        </span>
      ))}
    </div>
  )
}